function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "#B6B6B6",
  fillRule: "evenodd",
  d: "M8 2.5c4.73 0 7.8 5.03 7.93 5.24a.53.53 0 010 .52c-.13.24-3.2 5.24-7.93 5.24C3.27 13.5.2 8.47.07 8.26a.53.53 0 010-.52C.2 7.53 3.27 2.5 8 2.5zm0 2a3.5 3.5 0 100 7 3.5 3.5 0 000-7zM8 6c.197.002.393.036.58.1A1 1 0 009 8a1 1 0 00.9-.58c.064.187.098.383.1.58a2 2 0 11-2-2z"
});

function SvgEyeEnable(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16
  }, props), _ref);
}

export default SvgEyeEnable;